import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon'

/** Remix Icon money-dollar-circle-fill — Figma `1:690`. */
export function SensemakerAmountIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 12 12">
      <path d="M6.00245 11C3.24102 11 1.00244 8.76143 1.00244 5.99998C1.00244 3.23858 3.24102 1 6.00245 1C8.76385 1 11.0025 3.23858 11.0025 5.99998C11.0025 8.76143 8.76385 11 6.00245 11ZM4.25244 6.99998V7.99998H5.50245V8.99998H6.50245V7.99998H7.00245C7.6928 7.99998 8.25245 7.44038 8.25245 6.74998C8.25245 6.05963 7.6928 5.49998 7.00245 5.49998H5.00245C4.86437 5.49998 4.75244 5.38808 4.75244 5.24998C4.75244 5.11193 4.86437 4.99997 5.00245 4.99997H7.75245V4H6.50245V3H5.50245V4H5.00245C4.31209 4 3.75244 4.55964 3.75244 5.24998C3.75244 5.94038 4.31209 6.49998 5.00245 6.49998H7.00245C7.1405 6.49998 7.25245 6.61193 7.25245 6.74998C7.25245 6.88808 7.1405 6.99998 7.00245 6.99998H4.25244Z" />
    </SvgIcon>
  )
}

/** Remix Icon calendar-event-fill — Figma `1:698`. */
export function SensemakerOnboardedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M17 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 13H11V17H6V13Z" />
    </SvgIcon>
  )
}

/** Remix Icon more-2-line — Figma `1:666` kebab menu. */
export function SensemakerCardMoreIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M12 3C10.9 3 10 3.9 10 5C10 6.1 10.9 7 12 7C13.1 7 14 6.1 14 5C14 3.9 13.1 3 12 3ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 17C10.9 17 10 17.9 10 19C10 20.1 10.9 21 12 21C13.1 21 14 20.1 14 19C14 17.9 13.1 17 12 17Z" />
    </SvgIcon>
  )
}
